
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(2,0,0,2,0,0)"}},[_c('defs',[_c('style',[_v('.a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}')])]),_c('title',[_v('synchronize-arrows-1')]),_c('path',{staticClass:"a",attrs:{"d":"M18.362,7A8.25,8.25,0,0,0,3.75,12.247V14.5"}}),_c('path',{staticClass:"a",attrs:{"d":"M6,17.908A8.25,8.25,0,0,0,20.25,12.247v-1.5"}}),_c('polyline',{staticClass:"a",attrs:{"points":"0.75 11.497 3.75 14.497 6.75 11.497"}}),_c('polyline',{staticClass:"a",attrs:{"points":"23.25 13.747 20.25 10.747 17.25 13.747"}})])])
          )
        }
      }
    